<div [formGroup]="form">
  <mat-form-field>
    <input
      matInput
      formControlName="appointment_time"
      name="appointment_time"
      type="text"
      placeholder="Appointment time"
      i18n-placeholder="@@formLabelAppointmentTime"
    />
    <mat-hint align="start">HH:mm</mat-hint>
    <mat-error *ngIf="form.get('appointment_time').errors">
      Format is not valid. Example: 14:45
    </mat-error>
  </mat-form-field>
</div>
